/**
 * Simple Base58 encode/decode used for friendly URLs and obfuscating
 * the values of integer based IDs from the users.
 */
/* eslint-disable */
/**
 * Defines the base alphabet for encoding integers.
 * Contains 0-9, a-z, A-Z in scrambled, total of 58 characters
 * @type {string}
 */
const alphabet = '4b7VCTpJvfA2ds5r3yxijwezPH6GXL1cEZKFQtaUSkq9hnYoBWRD8umNMg';
const base = alphabet.length;
const Base58 = {
    encode(num) {
        let mod;
        let str;
        if (!/^\d+$/.test(num)) {
            throw new Error('Value passed is not an integer.');
        }
        if (typeof num !== 'number') {
            num = parseInt(num, 10);
        }
        str = '';
        while (num >= base) {
            mod = num % base;
            str = alphabet[mod] + str;
            num = (num - mod) / base;
        }
        return alphabet[num] + str;
    },

    decode(str) {
        let char;
        let charIndex;
        let i = 0;
        let index = 0;
        let len;
        let num;
        const ref = str.split('').reverse();
        num = 0;
        for (len = ref.length; i < len; index = ++i) {
            char = ref[index];
            if ((charIndex = alphabet.indexOf(char)) === -1) {
                throw new Error('Value passed is not a valid BaseEncode string.');
            }
            num += charIndex * Math.pow(base, index);
        }
        return num;
    },
};

export default Base58;
